
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { PodcastType, PodcastPayloadType } from "@/common/types/podcast";

export async function podcastList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/podcast/list${queryString}`
    );
}

export async function podcastGet(
    podcast_id: string
) {
    return await clientAxios.get(
        `admin/podcast/${podcast_id}/show`
    );
}

export async function podcastCreate(
    payload: PodcastPayloadType
) {
    return await clientAxios.post(
        `admin/podcast/create`,
        payload
    );
}

export async function podcastPatch(
    podcast_id: string,
    payload: Partial<PodcastType>
) {
    return await clientAxios.patch(
        `admin/podcast/${podcast_id}/patch`,
        { payload }
    );
}

export async function podcastDel(
    podcast_id: string,
) {
    return await clientAxios.del(
        `admin/podcast/${podcast_id}/delete`,
    );
}
